<div class="row justify-content-center align-items-center mt-5">
  <div class="col-sm-12 col-md-6 col-lg-4">
    <app-reset-password
      *ngIf="currentUser"
      [standalone]="true"
      [username]="currentUser?.userName">
    </app-reset-password>
  </div>
</div>
